import { Step } from 'react-joyride';
import { t } from 'locale';
import { routes } from 'routes';
import React from 'react';

import { localeKeys } from 'enums/localeKeys';

export const getSteps = ({
  disableBalanceTransfer,
  disableCloseAccount,
  isManualSwitch,
  isMobile
}: {
  disableBalanceTransfer: boolean;
  disableCloseAccount: boolean;
  isManualSwitch: boolean;
  isMobile: boolean;
}): Step[] => {
  const isTransferBalanceEnabled = !disableBalanceTransfer && !isManualSwitch;

  return [
    {
      disableBeacon: true,
      placement: 'right',
      target: isMobile ? '#mobile-sidebar-item-bills-button' : '#sidebar-item-bills-button',
      title: t(localeKeys.appMenuMoveMyBills),
      content: (
        <div className="flex flex-col">
          <p className="text-body-standard-regular text-general-80">
            {t(localeKeys.productOnboardingMoveBillsDescription)}
          </p>
        </div>
      ),
      data: {
        routeToBeforeStep: routes.bills.path,
        routeToAfterStep: routes.incomingPayments.path
      }
    },
    {
      disableBeacon: true,
      target: isMobile
        ? '#mobile-sidebar-item-incoming-payments-button'
        : '#sidebar-item-incoming-payments-button',
      placement: 'right',
      title: t(localeKeys.moveMySalary),
      content: (
        <div className="flex flex-col">
          <p className="text-body-standard-regular text-general-80">
            {t(localeKeys.productOnboardingMoveSalaryDescription)}
          </p>
        </div>
      ),
      data: {
        routeToAfterStep: isTransferBalanceEnabled
          ? routes.transferBalance.path
          : disableCloseAccount
          ? routes.helpCenter.path
          : routes.closeAccount.path
      }
    },
    isTransferBalanceEnabled && {
      disableBeacon: true,
      target: isMobile
        ? '#mobile-sidebar-item-transfer-balance-button'
        : '#sidebar-item-transfer-balance-button',
      placement: 'right',
      title: t(localeKeys.transferBalanceText),
      content: (
        <div className="flex flex-col">
          <p className="text-body-standard-regular text-general-80">
            {t(localeKeys.productOnboardingTransferBalanceDescription)}
          </p>
        </div>
      ),
      data: {
        routeToAfterStep: disableCloseAccount ? routes.helpCenter.path : routes.closeAccount.path
      }
    },
    !disableCloseAccount && {
      disableBeacon: true,
      target: isMobile
        ? '#mobile-sidebar-item-close-account-button'
        : '#sidebar-item-close-account-button',
      placement: 'right',
      title: t(localeKeys.closeAccountText),
      content: (
        <div className="flex flex-col">
          <p className="text-body-standard-regular text-general-80">
            {t(localeKeys.productOnboardingCloseAccountDescription)}
          </p>
        </div>
      ),
      data: {
        routeToAfterStep: routes.helpCenter.path
      }
    },
    {
      disableBeacon: true,
      target: isMobile
        ? '#mobile-sidebar-item-help-centre-button'
        : '#sidebar-item-help-centre-button',
      placement: 'right',
      title: t(localeKeys.helpCentre),
      content: (
        <div className="flex flex-col">
          <p className="text-body-standard-regular text-general-80">
            {t(localeKeys.productOnboardingHelpCenterDescription)}
          </p>
        </div>
      ),
      data: {
        routeToAfterStep: routes.overview.path,
        shouldToggleDrawerMenu: true
      }
    },
    !isManualSwitch && {
      disableBeacon: true,
      target: '#overview-card-banks',
      placement: 'bottom',
      title: t(localeKeys.productOnboardingBanksCardTitle),
      content: (
        <div className="flex flex-col">
          <p className="text-body-standard-regular text-general-80">
            {t(localeKeys.productOnboardingBanksCardDescription)}
          </p>
        </div>
      ),
      data: {
        routeToAfterStep: routes.overview.path
      }
    },
    {
      disableBeacon: true,
      target: '#overview-card-featured',
      placement: 'bottom',
      title: t(localeKeys.productOnboardingNextActionTitle),
      content: (
        <div className="flex flex-col">
          <p className="text-body-standard-regular text-general-80">
            {t(localeKeys.productOnboardingNextActionDescription)}
          </p>
        </div>
      ),
      data: {
        routeToAfterStep: routes.overview.path
      }
    }
  ].filter(Boolean) as Step[];
};
